import { useGetCurrentUser } from '@entities/user/api/useGetCurrentUser';
import type { TUser } from '@entities/user/lib/types';
import { INIT_USER_DATA } from './initData';
export const useCurrentUserData = (): TUser => {
  const {
    data
  } = useGetCurrentUser();
  return data || INIT_USER_DATA;
};